import React from 'react'
import {
	Table
} from 'reactstrap'
import Reflux from 'reflux'
import _ from 'lodash'

import CurrentRecipeStore from '~/stores/currentRecipe.js'

import RecipeIngredientsAdd from '~/modules/recipeIngredients/add.jsx'
import RecipeIngredientsEditRow from '~/modules/recipeIngredients/editRow.jsx'


export default class RecipeIngredientsEdit extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'recipeID',
			'recipeIngredients',
			'showIngredientsModal'
		]
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const theIngredients = (
			_.has(this.state, 'recipeIngredients')
			&& _.isArray(this.state.recipeIngredients)
			&& _.size(this.state.recipeIngredients) > 0
		)
			? this.state.recipeIngredients.map(
				(theIngredient, theIndex) =>
				<RecipeIngredientsEditRow
					key={theIngredient.recipeIngredientID}
					index={theIndex}
					recipeIngredientID={theIngredient.recipeIngredientID}
					recipeID={this.state.recipeID}
					ingredientID={theIngredient.ingredientID}
					ingredientName={theIngredient.ingredientName}
					ingredientTypeID={theIngredient.ingredientTypeID}
					ingredientTypeName={theIngredient.ingredientTypeName}
					quantityID={theIngredient.quantityID}
					quantityName={theIngredient.quantityName}
					amount={theIngredient.amount}
				/>
			)
			: null

		return (
			<Table size="sm" hover striped style={{ width: '100%' }}>
				<thead>
					<tr>
						<th width="10%">Amount</th>
						<th width="15%">Qty</th>
						<th width="30%">Ingredient</th>
						<th width="25%">Type</th>
						<th width="10%" />
						<th width="10%" />
					</tr>
				</thead>
				<tbody>
					{theIngredients}
				</tbody>
				<RecipeIngredientsAdd
					recipeID={this.state.recipeID}
				/>
			</Table>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeIngredients/edit.jsx